<script lang="ts">

  import { APP_CODE, APP_MODE, APP_VERSION } from "$lib/env"
  import { Button } from "$lib/components/ui/button"
  import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "$lib/components/ui/dialog"
  import { appStore } from "$lib/stores/app-store.svelte"
  import { deviceStore } from "$lib/stores/device-store.svelte"

  let { open, setOpen }: {
    open: boolean
    setOpen: (open: boolean) => void
  } = $props()

  const user = $derived(appStore.user)
  const device = $derived(deviceStore.device)
  const browser = $derived(typeof navigator === "undefined" ? "-" : navigator.userAgent)
  const versionApp = `${APP_CODE}-${APP_VERSION} (${APP_MODE.substring(0, 3)})`

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}
>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}
  >
    <DialogHeader>
      <DialogTitle>Informasi Aplikasi</DialogTitle>
    </DialogHeader>
    <div class="overflow-x-auto">
      <table class="w-full font-mono text-sm">
        <tbody>
        <tr>
          <td
            colspan="3"
            class="pb-1 text-xs text-muted-foreground"
          >Versi</td>
        </tr>
        <tr>
          <td class="pe-2">Aplikasi</td>
          <td class="pe-2">:</td>
          <td>{versionApp}</td>
        </tr>
        <tr>
          <td class="pe-2">Perangkat</td>
          <td class="pe-2">:</td>
          <td>{device.app_version || "-"}</td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="h-4"
          ></td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="pb-1 text-xs text-muted-foreground"
          >Perangkat</td>
        </tr>
        <tr>
          <td class="pe-2">ID</td>
          <td class="pe-2">:</td>
          <td>{device.device_id || "-"}</td>
        </tr>
        <tr>
          <td class="pe-2">Produk</td>
          <td class="pe-2">:</td>
          <td>{[device.device_brand, device.device_product].filter(Boolean).join(" ") || "-"}</td>
        </tr>
        <tr>
          <td class="pe-2">OS</td>
          <td class="pe-2">:</td>
          <td>{[device.device_os_code, device.device_os].filter(Boolean).join(" - ") || "-"}</td>
        </tr>
        <tr>
          <td class="pe-2">Zona Waktu</td>
          <td class="pe-2">:</td>
          <td>{device.region_id || "-"}</td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="h-4"
          ></td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="pb-1 text-xs text-muted-foreground"
          >Tambahan</td>
        </tr>
        <tr>
          <td class="pe-2">User</td>
          <td class="pe-2">:</td>
          <td>{user?.username || "-"}</td>
        </tr>
        <tr class="align-text-top">
          <td class="pe-2">Browser</td>
          <td class="pe-2">:</td>
          <td class="break-all">{browser}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <DialogFooter>
      <Button
        variant="outline"
        onclick={() => setOpen(false)}
      >Tutup</Button>
    </DialogFooter>
  </DialogContent>
</Dialog>